module.exports = __webpack_public_path__ + "static/media/body.ed115cd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/body.png
// module id = 111
// module chunks = 6